import {
  Busev as BusEV,
  S,
  S1,
  S2,
  S20,
  S3,
  S4,
  S5,
  S6,
  S7,
  S8,
} from "../../components/icons";

const lineIcons: Record<string, React.ReactNode> = {
  busev: <BusEV />,
  s: <S />,
  s1: <S1 />,
  s2: <S2 />,
  s20: <S20 />,
  s3: <S3 />,
  s4: <S4 />,
  s5: <S5 />,
  s6: <S6 />,
  s7: <S7 />,
  s8: <S8 />,
};

["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s20", "ev", "sev"].forEach(
  (line) => {
    lineIcons[`bus${line}`] = lineIcons.busev;
  },
);

export default lineIcons;
